import _Vue from "vue";

import { ApiClient } from '@/service/ApiClient';
import { InstallAppUtil } from '@/util/InstallAppUtil';
import { ValidationUtil } from '@/util/ValidationUtil';

// export type PluginFunction<T> = (Vue: typeof _Vue, options?: T) => void;
export default function ApiClientPlugin(Vue: typeof _Vue): void {
  
  // Buefy helpers
  if(!Vue.prototype.$buefy)
    throw new Error(`Please load buefy plugin first!`);

  Vue.prototype.$toastError = (error:string) => {

    Vue.prototype.$buefy.toast.open({
      message: `<b>Error:</b> ${error}`,
      type: 'is-danger',
      position: 'is-top',
      duration: 5000
    })
  };

  Vue.prototype.$toastInfo = (infoMsg:string) => {

    Vue.prototype.$buefy.toast.open({
      message: infoMsg,
      type: 'is-success',
      position: 'is-top',
      duration: 3000
    })
  };

  const validUtil = new ValidationUtil();

  // ontap data manipulation util
  Vue.prototype.$appUtil = new InstallAppUtil(validUtil);

  // API client
  Vue.prototype.$apiClient = new ApiClient();
}

// Adds Buefy method signatures to Vue instance (ie this.$toastError)
declare module 'vue/types/vue' {
  interface Vue {
      $apiClient: ApiClient;
      $appUtil: InstallAppUtil;
      $toastError: (error:string) => void;
      $toastInfo: (infoMsg:string) => void;
  }
}